/**
 * Is a camera currently connected?
 *
 * The answer was written inline in half a dozen places, each with a slightly different set of
 * strings — CameraTree accepts active/streaming/online, the cloud recordings picker accepted
 * active/streaming/recording, so the same camera could read online in one list and offline in
 * the next. The union of every set that has been used in earnest lives here instead.
 *
 * `recording` counts: it is what the local backend reports while a pipeline is running, which
 * is the most connected a camera ever is.
 */
const ONLINE_STATUSES = new Set(['active', 'streaming', 'recording', 'online']);

export function isCameraOnline(status?: string | null): boolean {
  return !!status && ONLINE_STATUSES.has(status);
}
